<script lang="ts" context="module">
  export const finalDownloadBtnStore = writable({
    disabled: true,
    disabledTooltip: 'Please wait'
  });
</script>

<script lang="ts">
  import {TopnavEvents} from '@/utils/top-nav-next-custom-events';
  import loadingStore from '@/pages/preview/loading-store';

  import Swal from 'sweetalert2';
  import {downloadDialog, draftStore, user} from '@/store';
  import {writable} from 'svelte/store';
  import {tooltip} from '../actions/tippy-action';
  import {canAccess} from '@/utils/common';
  import {Features} from '@/types/common';

  export let saveNewProject = async () => false;

  // currently disabled
  let isStep4DownloadClicked = false;

  let showDropdown = false;
  let isDisabled = true;
  let downloadBtnNode: any = null;

  const closeDropDown = (event: Event) => (showDropdown = false);
  let disabledtippy: any = null;
  $: {
    isDisabled = $loadingStore || $finalDownloadBtnStore.disabled;
    if (disabledtippy && disabledtippy.destroy) {
      disabledtippy.destroy();
      disabledtippy = null;
    }
    if ($finalDownloadBtnStore.disabled && $finalDownloadBtnStore.disabledTooltip && downloadBtnNode) {
      disabledtippy = tooltip(downloadBtnNode, $finalDownloadBtnStore.disabledTooltip);
    }
    (showDropdown && setTimeout(() => window.addEventListener('click', closeDropDown))) ||
      window.removeEventListener('click', closeDropDown);
  }

  const options = [
    {
      title: 'Highest Quality',
      description: 'Default method & Most Used',
      isRecommended: true,
      isShare: false,
      icon: '',
      action: async () => {
        if (!$draftStore.isProject) await saveNewProject();
        window.dispatchEvent(new CustomEvent(TopnavEvents.download, {detail: {qualityPreset: 'default'}}));
        showDropdown = false;
        isStep4DownloadClicked = true;
      }
    },
    {
      title: 'Smaller Size',
      description: 'Required when posting with social media schedulers',
      isRecommended: false,
      isShare: false,
      icon: '',
      action: async () => {
        if (!$draftStore.isProject) await saveNewProject();
        window.dispatchEvent(new CustomEvent(TopnavEvents.download, {detail: {qualityPreset: 'medium'}}));
        showDropdown = false;
        isStep4DownloadClicked = true;
      }
    },
    {
      title: 'Export to Sermon Send',
      description: 'Add to Sermon Send library',
      isRecommended: false,
      isShare: true,
      icon: 'https://storage.googleapis.com/sermonshots-local-storage/images/sermonsend.png',
      action: async () => {
        if (!$draftStore.isProject) await saveNewProject();
        window.dispatchEvent(new CustomEvent(TopnavEvents.download, {detail: {qualityPreset: 'default'}}));
        showDropdown = false;
        isStep4DownloadClicked = true;
      }
    }
  ];
</script>

<div class="h-full w-full">
  {#if isStep4DownloadClicked && false}
    <!-- DISABLED FOR NOW -->
    <div class="flex h-full w-full">
      <button
        on:click={() => downloadDialog.set(true)}
        class="flex w-full items-center gap-2 rounded-lg border border-rose-500 bg-rose-500 px-4 py-2 text-zinc-100 transition-all hover:bg-rose-600"
        disabled={isDisabled}
      >
        <i class="fa-solid fa-download"></i>
        Download
      </button>
    </div>
  {:else}
    <div
      bind:this={downloadBtnNode}
      class="flex h-full w-full gap-2 rounded-lg bg-gradient-to-r from-primary to-secondary px-4 py-2 text-white {isDisabled
        ? 'cursor-not-allowed'
        : 'cursor-pointer'}"
    >
      <button
        on:click={() => options[0].action()}
        class="flex w-full items-center justify-center gap-2 transition-all {isDisabled
          ? 'cursor-not-allowed'
          : 'cursor-pointer'}"
        disabled={isDisabled}
      >
        <i class="fa-solid fa-download"></i>
        Download
      </button>
      <button
        on:click={() => (showDropdown = !showDropdown)}
        class="transition-all {isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}"
        disabled={isDisabled}
      >
        <i class="fa-solid fa-chevron-down"></i>
      </button>
    </div>
    <div
      class="absolute right-0 z-10 mt-1 grid w-[20rem] overflow-hidden rounded-lg rounded-bl-lg bg-white p-2 {showDropdown ===
      true
        ? ''
        : 'hidden'} text-gray-700"
      style="z-index: 99;"
    >
      {#each options as option, i}
        {#if option.isShare}
          <p class="px-4 pt-2 text-xs font-bold text-secondary-200">Send To</p>
        {/if}
        <button
          on:click={option.action}
          class="grid rounded-lg p-4 transition-all hover:bg-gray-100"
          disabled={isDisabled}
        >
          <div class="flex items-center gap-1">
            <span class="font-medium">{option.title}</span>
            {#if option.icon !== ''}
              <span class="ml-auto">
                <img src={option.icon} class="grayscale" alt="sermon-send" width="20" height="20" />
              </span>
            {/if}
            <span
              class="ml-auto rounded bg-orange-100 px-2 py-1 text-xs font-bold text-secondary-200 {option.isRecommended
                ? ''
                : 'hidden'}">RECOMMENDED</span
            >
          </div>
          <p class="pt-1 text-start text-xs font-light">{option.description}</p>
        </button>
      {/each}
    </div>
  {/if}
</div>
